// extracted by mini-css-extract-plugin
export var container = "_si-0";
export var table = "_si-2";
export var tableWrapper = "_si-1";